import React from 'react';
import { displayLabel } from '../labels';

// Plain data table for pipeline rows. `fields` is the output schema
// ([{ key, label }]) and `rows` an array of row hashes. `labels` optionally
// maps a column key to a custom header label (overrides the schema label).
export default function TableViz({ fields, rows, labels }) {
  const columns = fields || [];
  const shown = (rows || []).slice(0, 500);

  if (columns.length === 0 || shown.length === 0) {
    return <div className="viz-empty">No rows</div>;
  }

  return (
    <div className="viz-table">
      <table>
        <thead>
          <tr>
            {columns.map((f) => (
              <th key={f.key}>{displayLabel(labels, f.key, f.label || f.key)}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {shown.map((row, i) => (
            <tr key={i}>
              {columns.map((f) => (
                <td key={f.key}>{formatCell(row[f.key])}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      {rows.length > shown.length && (
        <div className="viz-table-note">
          Showing {shown.length} of {rows.length} rows
        </div>
      )}
    </div>
  );
}

function formatCell(value) {
  if (value === null || value === undefined) return '';
  if (Array.isArray(value)) return value.join(', ');
  if (typeof value === 'number') return Number.isInteger(value) ? String(value) : value.toFixed(2);
  if (typeof value === 'boolean') return value ? 'yes' : 'no';
  return String(value);
}
